import { render, staticRenderFns } from "./harvest-regional-performance.vue?vue&type=template&id=3bb3b254&scoped=true&"
import script from "./harvest-regional-performance.vue?vue&type=script&lang=js&"
export * from "./harvest-regional-performance.vue?vue&type=script&lang=js&"
import style0 from "./harvest-regional-performance.vue?vue&type=style&index=0&id=3bb3b254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb3b254",
  null
  
)

export default component.exports